let slideDiferenciais,
  sliderHome,
  stories;
  
  // sliderMenuCollection;

$('.product-form__label').on('click', function () {
  $(this).closest('.product-form__input').removeClass('block-swatch classe-erro');
})

function slidesDesktop() {
  if ($('.slider-diferenciais').length) {
    slideDiferenciais = new Swiper(".slider-diferenciais", {
      slidesPerView: 1.8,
      spaceBetween: 1.5,
      breakpoints: {
        1024: {
          spaceBetween: 1.5,
          slidesPerView: 5
        }
      }
    })
  };
  if ($('.slider-home').length) {
    sliderHome = new Swiper(".slider-home", {
      effect: "creative",
      loop: true,
      autoHeight: true,
      creativeEffect: {
        prev: {
          shadow: true,
          translate: ["-20%", 0, -1],
        },
        next: {
          translate: ["100%", 0, 0],
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      //mousewheel: true,
      keyboard: true,
    });
  };
  if ($('.stories-slide').length) {
    stories = new Swiper(".stories-slide", {
      slidesPerView: "auto",
      spaceBetween: 16,
      centerInsufficientSlides: true,
      loop: true,
      breakpoints: {
        1024: {
          slidesPerView: "auto",
          spaceBetween: 16
        }
      }
    });
  };

  // if ($('.slider-collection-menu').length) {
  // sliderMenuCollection = new Swiper(".slider-collection-menu", {
  //     slidesPerView: 6.3,
  //     spaceBetween: 30,
  //     freeMode: true,
  //     mousewheel: true,
  //     pagination: {
  //       el: ".slider-collection-menu .swiper-pagination",
  //       type: "progressbar",
  //     },
  //     navigation: {
  //       nextEl: ".slider-collection-menu .swiper-button-next",
  //       prevEl: ".slider-collection-menu .swiper-button-prev",
  //     },
  //   });
  // }
}

document.addEventListener("DOMContentLoaded", function () {
  slidesDesktop();
})

if ($(window).width() <= 767) {
  stories?.destroy(true, true);
  slideDiferenciais?.destroy(true, true);
  // $('.slider-collection-menu.swiper-initialized').each(function () {
  //   this.swiper.destroy(true, true);
  // });
}

$(window).on("resize", function () {
  if ($(window).width() <= 767) {
    stories?.destroy(true, true);
    slideDiferenciais?.destroy(true, true);
    // $('.slider-collection-menu.swiper-initialized').each(function () {
    //   this.swiper.destroy(true, true);
    // });
  } else {
    slidesDesktop();
  }
});

$('.menu-lv-item.menu-lv-1').each(function () {
  var $this = $(this); // Armazena a referência atual do jQuery
  var largura = $this.outerWidth(); // Captura a largura do elemento
  var estiloAtual = $this.attr('style') || ''; // Pega o estilo atual, se houver
  $this.attr('style', estiloAtual + (estiloAtual ? '; ' : '') + '--width: ' + largura + 'px'); // Atualiza o atributo style
});

let navTamanhoGrid;
let navModelagemGrid;
let colorList;

window.sliderNavGrid = function () {
}

window.checkSlidesForNavigation = function (swiper) {
}

window.sliderNavGrid();

$(document).on('click', '[option-check-variant]', function () {
  console.log("Teste")
  let clickedOption = $(this);
  let containerGridVariants = clickedOption.closest('.variants-container-grid');
  let atualSelectorVariant = clickedOption.closest('.variant-selector-grid');
  let value = clickedOption.attr('option-check-variant');
  let json;
  let option = atualSelectorVariant.attr('optionIndex');
  let url = containerGridVariants.attr('url-product') + '?view=json_quick_view';

  $(this).closest('.card').find('.quick-add-bubble')?.attr('data-product-handle', $(this).attr('data-handle'));
  $(this).closest('.card').find('[href]')?.attr('href', $(this).attr('url-product'));

  $.get(url, function (data) {
    let html = $('<div></div>').html(data);
    html = html.find('[product-json]').html();
    json = JSON.parse(html);

    var result = json.filter(function (item) {
      return item[option] === value;
    });

    if (atualSelectorVariant.next('.variant-selector-grid').length > 0) {

      nextOptionsList = atualSelectorVariant.next('.variant-selector-grid');
      let maxSlides = nextOptionsList.attr('maxSlider');
      let swiperItem = nextOptionsList.find('.swiper');
      let option = nextOptionsList.attr('optionIndex');

      var newOptions = result.map(function (item) {
        return item[option];
      });


      swiperItem.each(function () {
        if (this.swiper) {
          this.swiper?.destroy(true, true);
        }
      });

      let swiperWrapper = nextOptionsList.find('.swiper-wrapper');

      swiperWrapper.empty();

      swiperWrapper.append('<div class="swiper-slide"><button return-options-variant class="return-option"><svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="none"> <path d="M4 10L3.64645 10.3536L3.29289 10L3.64645 9.64645L4 10ZM20.5 18C20.5 18.2761 20.2761 18.5 20 18.5C19.7239 18.5 19.5 18.2761 19.5 18L20.5 18ZM8.64645 15.3536L3.64645 10.3536L4.35355 9.64645L9.35355 14.6464L8.64645 15.3536ZM3.64645 9.64645L8.64645 4.64645L9.35355 5.35355L4.35355 10.3536L3.64645 9.64645ZM4 9.5L14 9.5L14 10.5L4 10.5L4 9.5ZM20.5 16L20.5 18L19.5 18L19.5 16L20.5 16ZM14 9.5C17.5898 9.5 20.5 12.4101 20.5 16L19.5 16C19.5 12.9624 17.0376 10.5 14 10.5L14 9.5Z" fill="#222222"/> </svg></button></div>');

      $.each(result, function (index, variant) {
        var slide = $('<div class="swiper-slide"></div>');

        if (variant.option2) {

          if (variant.available === true) {
            var button = $('<button></button>')
              .attr('option-check-variant', variant[option])
              .attr('variant-id', variant.id)
              .text(variant[option]);
          } else {
            var button = $('<button></button>')
              .attr('option-check-variant', variant[option])
              .attr('variant-id', variant.id)
              .attr('disabled', true)
              .text(variant[option]);
          }
          slide.append(button);
        }

        swiperWrapper.append(slide);
      });

      window.sliderNavGrid();

      atualSelectorVariant.hide();
      nextOptionsList.show();

    } else {
      let variantId = parseInt(clickedOption.attr('variant-id'));
      let formData = {
        'items': [{
          'id': variantId,
          'quantity': 1
        }]
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => {
          Shopify.getCart((cart) => {
            window.updateCart(cart);
            document.body.classList.add('cart-sidebar-show');
          })
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  })

})
$(document).on('click', '[fast-buy-grid-unic]', function () {
  let variantId = parseInt($(this).attr('fast-buy-grid-unic'));
  let formData = {
    'items': [{
      'id': variantId,
      'quantity': 1
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      Shopify.getCart((cart) => {
        window.updateCart(cart);
        document.body.classList.add('cart-sidebar-show');
      })
    })
    .catch((error) => {
      console.error('Error:', error);
    });
})
$(document).on('click', '[return-options-variant]', function () {
  let atualSelectorVariant = $(this).closest('.variant-selector-grid');
  atualSelectorVariant.hide();
  atualSelectorVariant.prev('.variant-selector-grid').show();
})

function normalizeQuickShopValue(value) {
  return String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

function getQuickShopSelectedSize($form) {
  const $checkedVisibleOption = $form
    .find('.selector-wrapper:not([style*="display: none"]) input.single-option:checked')
    .first();

  if ($checkedVisibleOption.length) {
    return $checkedVisibleOption.val();
  }

  const $checkedSizeOption = $form
    .find('.selector-wrapper input.single-option:checked')
    .filter(function () {
      const $wrapper = $(this).closest('.selector-wrapper');
      const labelText = normalizeQuickShopValue($wrapper.find('.form-label').text());

      return (
        labelText.includes('tamanho') ||
        labelText.includes('size') ||
        labelText.includes('numeracao') ||
        labelText.includes('numero')
      );
    })
    .first();

  if ($checkedSizeOption.length) {
    return $checkedSizeOption.val();
  }

  return null;
}

function getSizeOptionIndexFromProduct(productData, fallbackPosition) {
  if (fallbackPosition && !Number.isNaN(Number(fallbackPosition))) {
    return Number(fallbackPosition) - 1;
  }

  if (!productData || !productData.options) {
    return 0;
  }

  const options = productData.options;

  for (let i = 0; i < options.length; i++) {
    const option = options[i];
    const optionName = typeof option === 'string' ? option : option.name;
    const normalizedOptionName = normalizeQuickShopValue(optionName);

    if (
      normalizedOptionName.includes('tamanho') ||
      normalizedOptionName.includes('size') ||
      normalizedOptionName.includes('numeracao') ||
      normalizedOptionName.includes('numero')
    ) {
      return i;
    }
  }

  return 0;
}

function fetchProductByHandle(handle) {
  if (!handle) {
    return Promise.reject(new Error('Handle não informado.'));
  }

  window.__quickShopProductCache = window.__quickShopProductCache || {};
  window.__quickShopProductRequests = window.__quickShopProductRequests || {};

  if (window.__quickShopProductCache[handle]) {
    return Promise.resolve(window.__quickShopProductCache[handle]);
  }

  if (window.__quickShopProductRequests[handle]) {
    return window.__quickShopProductRequests[handle];
  }

  window.__quickShopProductRequests[handle] = fetch(`/products/${handle}.js`)
    .then(function (response) {
      if (!response.ok) {
        throw new Error(`Erro ao buscar produto: ${handle}`);
      }

      return response.json();
    })
    .then(function (productData) {
      window.__quickShopProductCache[handle] = productData;
      delete window.__quickShopProductRequests[handle];
      return productData;
    })
    .catch(function (error) {
      delete window.__quickShopProductRequests[handle];
      throw error;
    });

  return window.__quickShopProductRequests[handle];
}

function findVariantBySelectedSize(productData, selectedSize, sizePosition) {
  if (!productData || !productData.variants || !selectedSize) {
    return null;
  }

  const normalizedSelectedSize = normalizeQuickShopValue(selectedSize);
  const sizeIndex = getSizeOptionIndexFromProduct(productData, sizePosition);

  let matchedVariant = productData.variants.find(function (variant) {
    const optionValue = variant.options && variant.options[sizeIndex];

    return (
      variant.available &&
      normalizeQuickShopValue(optionValue) === normalizedSelectedSize
    );
  });

  if (!matchedVariant) {
    matchedVariant = productData.variants.find(function (variant) {
      if (!variant.available || !variant.options) return false;

      return variant.options.some(function (optionValue) {
        return normalizeQuickShopValue(optionValue) === normalizedSelectedSize;
      });
    });
  }

  return matchedVariant || null;
}

function updateQuickShopFormVariant($form, variantId) {
  if (!variantId) return;

  const variantIdString = String(variantId);
  const $select = $form.find('select[name="id"]').first();
  const $input = $form.find('input[name="id"]').first();

  if ($select.length) {
    let $option = $select.find(`option[value="${variantIdString}"]`);

    if (!$option.length) {
      $select.append(
        `<option value="${variantIdString}" data-value="${variantIdString}">${variantIdString}</option>`
      );
      $option = $select.find(`option[value="${variantIdString}"]`);
    }

    $select.val(variantIdString);
    $option.prop('selected', true);
    $select.trigger('change');
  }

  if ($input.length) {
    $input.val(variantIdString).trigger('change');
  }
}

function refreshAndOpenSidebarCart(callback) {
  const openCartSidebar = function () {
    $('[data-cancel-quickshop-popup]').trigger('click');

    const $cartTrigger = $(
      '[data-cart-sidebar], ' +
      '[data-open-cart-sidebar], ' +
      '[data-cart-drawer], ' +
      '[data-open-cart], ' +
      '[data-cart-preview], ' +
      '[data-cart-toggle], ' +
      '.header__icon--cart, ' +
      '.cart-icon, ' +
      '.site-header__cart, ' +
      '.header-cart, ' +
      'a[href="/cart"], ' +
      'a[href*="/cart"]'
    )
      .filter(function () {
        return !$(this).closest('form').length;
      })
      .first();

    if ($cartTrigger.length) {
      $cartTrigger.trigger('click');
    }

    $('body').addClass(
      'cart-sidebar-show cart-drawer-show cart-show open-cart show-cart'
    );

    $(
      '.halo-cart-sidebar, ' +
      '.cart-sidebar, ' +
      '.cart-drawer, ' +
      '.previewCart, ' +
      '.previewCart-wrapper, ' +
      '[data-cart-sidebar], ' +
      '[data-cart-drawer]'
    ).addClass('is-open active show open');

    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('cart:drawer:open'));
    document.dispatchEvent(new CustomEvent('halo:cart:open'));

    if (typeof callback === 'function') {
      callback();
    }
  };

  const afterCartUpdated = function (cart) {
    if (cart && typeof cart.item_count !== 'undefined') {
      $(
        '[data-cart-count], ' +
        '.cart-count, ' +
        '.header__icon--cart .count, ' +
        '.cart-icon .count, ' +
        '.cart-count-bubble span'
      )
        .text(cart.item_count)
        .attr('data-cart-count', cart.item_count);
    }

    setTimeout(openCartSidebar, 200);
  };

  if (
    typeof Shopify !== 'undefined' &&
    typeof Shopify.getCart === 'function' &&
    window.halo &&
    typeof window.halo.updateSidebarCart === 'function'
  ) {
    Shopify.getCart(function (cart) {
      window.halo.updateSidebarCart(cart);
      afterCartUpdated(cart);
    });

    return;
  }

  fetch('/cart.js')
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      if (window.halo && typeof window.halo.updateSidebarCart === 'function') {
        window.halo.updateSidebarCart(cart);
      }

      document.dispatchEvent(
        new CustomEvent('cart:refresh', { detail: { cart: cart } })
      );
      document.dispatchEvent(
        new CustomEvent('cart:update', { detail: { cart: cart } })
      );

      afterCartUpdated(cart);
    })
    .catch(function () {
      openCartSidebar();
    });
}

$(document).on('click', '.thumb-color-meta', function (e) {
  e.preventDefault();
  e.stopPropagation();

  const $clicked = $(this);
  const $containerColor = $clicked.closest('.colors-list-thumbs');
  const $card = $clicked.closest('.card');
  const $productItem = $clicked.closest('.product-item');

  if (!$card.length) return;

  const clickedHandle = $clicked.attr('data-handle');
  const clickedUrl =
    $clicked.attr('data-url-product') || $clicked.attr('data-product-url');
  const clickedProductUrl =
    $clicked.attr('data-product-url') || clickedUrl;
  const clickedImage = $clicked.attr('data-image-feature');
  const clickedSecondImage = $clicked.attr('data-second-image');
  const clickedTitle = $clicked.attr('data-product-title');
  const clickedPrice = $clicked.attr('data-price');
  const clickedPriceHtml = $clicked.attr('data-price-html');
  const clickedVariantId = $clicked.attr('data-variant-id');
  const clickedSizePosition = $clicked.attr('data-index-size');

  const originalProductHandle =
    $clicked.closest('.container-colorlist').attr('data-card-product-handle') ||
    $clicked.closest('[data-product-handle]').attr('data-product-handle') ||
    clickedHandle;

  window.__quickShopSelectedColorByOriginalHandle =
    window.__quickShopSelectedColorByOriginalHandle || {};

  window.__quickShopSelectedColorByOriginalHandle[originalProductHandle] = {
    handle: clickedHandle,
    variantId: clickedVariantId,
    sizePosition: clickedSizePosition,
    productUrl: clickedProductUrl
  };

  if (!clickedHandle || !clickedUrl) return;

  $containerColor
    .find('.thumb-color-meta')
    .removeClass('active')
    .removeAttr('aria-current');

  $clicked.addClass('active').attr('aria-current', 'true');

  const $quickShopScope = $clicked.closest(
    '.product-item, .card-product, .card, .product-card'
  );

  $quickShopScope
    .find('form.variants[action*="/cart/add"], form[action*="/cart/add"]')
    .attr('data-selected-product-handle', clickedHandle)
    .attr('data-selected-size-position', clickedSizePosition || '')
    .attr('data-selected-variant-id', clickedVariantId || '');

  $card.attr('data-selected-product-handle', clickedHandle);
  $card.attr('data-selected-product-url', clickedProductUrl);
  $card.attr('data-selected-size-position', clickedSizePosition || '');

  if (clickedVariantId) {
    $card.attr('data-selected-variant-id', clickedVariantId);
  }

  if ($productItem.length) {
    $productItem.attr('data-product-handle', clickedHandle);
    $productItem.attr('data-selected-product-handle', clickedHandle);
    $productItem.attr('data-selected-product-url', clickedProductUrl);
    $productItem.attr('data-selected-size-position', clickedSizePosition || '');

    if (clickedVariantId) {
      $productItem.attr('data-variant-id', clickedVariantId);
      $productItem.attr('data-selected-variant-id', clickedVariantId);
    }
  }

  $card.find('a[href*="/products/"]').each(function () {
    const $link = $(this);

    if ($link.closest('.colors-list-thumbs').length) return;

    $link.attr('href', clickedUrl);
  });

  if (clickedTitle) {
    const $titleLink = $card
      .find(
        '.card-title a, ' +
        '.card__heading a, ' +
        '.card-information a[href*="/products/"], ' +
        'a.full-unstyled-link'
      )
      .first();

    if ($titleLink.length) {
      $titleLink.text(clickedTitle);
      $titleLink.attr('href', clickedUrl);
    } else {
      const $titleElement = $card
        .find(
          '.card-title, ' +
          '.card__heading, ' +
          '.card-information__text, ' +
          '.card-product__title'
        )
        .first();

      if ($titleElement.length) {
        $titleElement.text(clickedTitle);
      }
    }
  }

  if (clickedImage) {
    const $images = $card
      .find(
        '.card-product img, ' +
        '.card__media img, ' +
        '.media img, ' +
        'img.motion-reduce'
      )
      .filter(function () {
        return !$(this).closest('.colors-list-thumbs').length;
      });

    $images.each(function (index) {
      const $image = $(this);
      const nextImage =
        index === 1 && clickedSecondImage ? clickedSecondImage : clickedImage;

      $image.attr('src', nextImage);
      $image.attr('srcset', '');

      if (clickedTitle) {
        $image.attr('alt', clickedTitle);
      }
    });
  }

  if (clickedPriceHtml) {
    const $currentPriceBlock = $card
      .find('.price-with-installments, .card-price, .price')
      .first();

    if ($currentPriceBlock.length) {
      $currentPriceBlock.replaceWith(clickedPriceHtml);
    }
  } else if (clickedPrice) {
    const $priceRegular = $card
      .find(
        '.price .price-item--regular, ' +
        '.price__regular .price-item, ' +
        '.card-price, ' +
        '.price-item'
      )
      .first();

    if ($priceRegular.length) {
      $priceRegular.text(clickedPrice);
    }
  }

  if (clickedVariantId) {
    $card.find('input[name="id"]').val(clickedVariantId);

    $card.find('[data-variant-id]').each(function () {
      $(this).attr('data-variant-id', clickedVariantId);
    });

    $card.find('[data-product-id]').each(function () {
      $(this).attr('data-product-id', clickedVariantId);
    });

    $card.find('form[action*="/cart/add"]').each(function () {
      const $form = $(this);
      const $input = $form.find('input[name="id"]');

      if ($input.length) {
        $input.val(clickedVariantId);
      }
    });
  }

  window.sliderNavGrid?.();
  window.updateSlideGridProduct?.();
});

function getQuickShopSelectedColorData($form) {
  window.__quickShopSelectedColorByOriginalHandle =
    window.__quickShopSelectedColorByOriginalHandle || {};

  const originalHandle =
    $form.attr('data-current-product-handle') ||
    $form
      .closest('.product-item, .card, .product-card')
      .find('.container-colorlist[data-card-product-handle]')
      .first()
      .attr('data-card-product-handle');

  if (!originalHandle) {
    return null;
  }

  const selectedData =
    window.__quickShopSelectedColorByOriginalHandle[originalHandle];

  if (!selectedData || !selectedData.handle) {
    return null;
  }

  if (selectedData.handle === originalHandle) {
    return null;
  }

  return {
    originalHandle: originalHandle,
    selectedHandle: selectedData.handle,
    selectedVariantId: selectedData.variantId,
    selectedSizePosition: selectedData.sizePosition
  };
}

function runCustomQuickShopAdd(form, event) {
  const $form = $(form);
  const colorData = getQuickShopSelectedColorData($form);

  if (!colorData) {
    return false;
  }

  const selectedSize = getQuickShopSelectedSize($form);

  if (!selectedSize) {
    return false;
  }

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  const $submitButton = $form
    .find('[type="submit"], [data-btn-addToCart]')
    .first();

  if ($submitButton.attr('aria-busy') === 'true') {
    return true;
  }

  $submitButton.addClass('is-loading').attr('aria-busy', 'true');

  fetchProductByHandle(colorData.selectedHandle)
    .then(function (productData) {
      const matchedVariant = findVariantBySelectedSize(
        productData,
        selectedSize,
        colorData.selectedSizePosition
      );

      if (!matchedVariant) {
        $submitButton.removeClass('is-loading').removeAttr('aria-busy');
        alert('Não encontramos esse tamanho para a cor selecionada.');
        return null;
      }

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: matchedVariant.id,
          quantity: 1
        })
      });
    })
    .then(function (response) {
      if (!response) return null;

      if (!response.ok) {
        return response.json().then(function (data) {
          throw data;
        });
      }

      return response.json();
    })
    .then(function (data) {
      if (!data) return;

      $submitButton.removeClass('is-loading').removeAttr('aria-busy');
      refreshAndOpenSidebarCart();
    })
    .catch(function (error) {
      console.error('Erro ao adicionar a variante correta:', error);

      $submitButton.removeClass('is-loading').removeAttr('aria-busy');

      const message =
        error && error.description
          ? error.description
          : 'Não foi possível adicionar essa variação ao carrinho. Tente novamente.';

      alert(message);
    });

  return true;
}

document.addEventListener(
  'click',
  function (event) {
    const button = event.target.closest(
      'form.variants[action*="/cart/add"] [type="submit"], ' +
      'form.variants[action*="/cart/add"] [data-btn-addToCart], ' +
      'form[action*="/cart/add"] [data-btn-addToCart]'
    );

    if (!button) return;

    const form = button.closest(
      'form.variants[action*="/cart/add"], form[action*="/cart/add"]'
    );

    if (!form) return;

    runCustomQuickShopAdd(form, event);
  },
  true
);

document.addEventListener(
  'submit',
  function (event) {
    const form = event.target;

    if (
      !form.matches(
        'form.variants[action*="/cart/add"], form[action*="/cart/add"]'
      )
    ) {
      return;
    }

    runCustomQuickShopAdd(form, event);
  },
  true
);

// Seleciona o elemento do formulário
var formElement = document.querySelector('.product-form.check-selected-variant form');

// Verifica se o elemento existe antes de adicionar o ouvinte de evento
if (formElement) {
  formElement.addEventListener('submit', function (event) {
    // Previne o envio imediato do formulário
    event.preventDefault();

    // Flag para controlar se o formulário deve ser enviado
    let shouldSubmit = true;

    // Seleciona todos os inputs do formulário
    const inputs = document.querySelectorAll('.product-form__input');

    // Percorre cada input para verificar a presença da classe '.block-swatch'
    inputs.forEach(input => {
      if (input.classList.contains('block-swatch')) {
        // Adiciona uma classe de erro se a classe '.block-swatch' for encontrada
        input.classList.add('classe-erro');
        shouldSubmit = false; // Marca o formulário para não ser enviado
      }
    });

    // Se nenhum elemento com '.block-swatch' foi encontrado, o formulário pode ser enviado
    if (shouldSubmit) {
      this.submit(); // Submete o formulário
    } else {
      // Aqui você pode adicionar qualquer lógica adicional para quando o formulário não puder ser enviado
      console.log('Um ou mais campos obrigatórios precisam ser selecionados.');
    }
  });
} else {
  console.log('O formulário especificado não foi encontrado.');
}

function updateArrowVisibility() {
  document.querySelectorAll('.container-colorlist').forEach(function (container) {
    var colorlist = container.querySelector('.colors-list-thumbs');
    var arrow = container.querySelector('.arrow');
    if(arrow) {
      // Calcula a largura total dos elementos .color
      var totalWidth = 0;
      colorlist.querySelectorAll('.thumb-color-meta').forEach(function (color) {
        totalWidth += color.offsetWidth + parseFloat(window.getComputedStyle(color).marginRight);
      });

      // Compara com a largura do container .colorlist
      if (totalWidth > colorlist.offsetWidth) {
        arrow.style.display = 'block'; // Mostra a seta se o conteúdo exceder o container
      } else {
        arrow.style.display = 'none'; // Oculta a seta se o conteúdo não exceder
      }
    }

  });
}

updateArrowVisibility();

document.addEventListener('click', function (e) {
  // Verifica se o clique foi em um elemento .arrow
  if (e.target.classList.contains('arrow')) {
    var container = e.target.closest('.container-colorlist');
    if (container) {
      var colorlist = container.querySelector('.colors-list-thumbs');
      var isAtStart = colorlist.scrollLeft === 0;

      if (isAtStart) {
        // Rola para o fim
        colorlist.scrollLeft = colorlist.scrollWidth;
        e.target.innerHTML = `<svg class="icon-arrow-back reverse" width="16" height="11" viewBox="0 0 16 11" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none"><path d="M5.5 15.5002C5.75781 15.5002 5.92969 15.4169 6.10156 15.2502L11 10.5002L9.79687 9.33356L6.35938 12.6669L6.35938 0H4.64063L4.64062 12.6669L1.20312 9.33356L0 10.5002L4.89844 15.2502C5.07031 15.4169 5.24219 15.5002 5.5 15.5002Z" transform="translate(16.0002) rotate(90)" fill="currentColor"></path></svg>`; // Muda o texto da seta
      } else {
        // Rola para o início
        colorlist.scrollLeft = 0;
        e.target.innerHTML = `<svg class="icon-arrow-back" width="16" height="11" viewBox="0 0 16 11" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none"><path d="M5.5 15.5002C5.75781 15.5002 5.92969 15.4169 6.10156 15.2502L11 10.5002L9.79687 9.33356L6.35938 12.6669L6.35938 0H4.64063L4.64062 12.6669L1.20312 9.33356L0 10.5002L4.89844 15.2502C5.07031 15.4169 5.24219 15.5002 5.5 15.5002Z" transform="translate(16.0002) rotate(90)" fill="currentColor"></path></svg>`; // Muda o texto da seta para a direção inicial
      }
    }
  }
});

// UPSELL Carrinho
window.upsellSliderInit = function () {
  var upsellCartSlider = new Swiper(".recommend-slider", {
    slidesPerView: "auto",
    spaceBetween: 15,
    slidesPerGroup: 3,
    freeMode: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true
    }
  });
}
function beforeSend() {
  $('#dropdown-cart').addClass('updating-cart');
}
function afterSend() {
  $('#dropdown-cart').removeClass('updating-cart');
}
$(document).on('submit', '.upsell-form', function (e) {
  e.preventDefault();

  const formData = new FormData(this);
  const serializedData = {};
  formData.forEach((value, key) => {
    serializedData[key] = value;
  });
  const jsonData = JSON.stringify(serializedData);

  // URL da API da Shopify para adicionar um item ao carrinho
  const addToCartUrl = window.Shopify.routes.root + 'cart/add.js';

  // Opções da requisição
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: jsonData,
  };

  beforeSend(); // Ação "before send" antes da requisição

  // Faz a requisição usando fetch com ação "before send" e "after send"
  fetch(addToCartUrl, requestOptions)
    .then((response) => {
      afterSend(); // Ação "after send" após a conclusão da requisição

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((data) => {
      // A requisição foi bem-sucedida, você pode atualizar o carrinho ou fazer outras ações necessárias aqui
      window.updateCart();
    })
    .catch((error) => {
      // Houve um erro na requisição, você pode tratar o erro aqui
      console.error('Error:', error);
    });
});
$(document).on('change', '.variants-product-selects select', function () {
  var $currentSelect = $(this);
  var $nextSelect = $currentSelect.closest('.variants-product-selects').find('select').eq($currentSelect.index() + 1);
  var productData = JSON.parse($currentSelect.closest('.infoProduct').find('[data-json-product]').text());

  const availableVariants = productData.filter(variant => variant.title.includes($currentSelect.val()) && variant.available);

  if ($nextSelect.length) {
    $currentSelect.closest('.infoProduct').find('.recommend-btn-add').prop('disabled', true);
    nextSelectName = $nextSelect.data('name');
    $nextSelect.html(`<option disabled="" selected="">${nextSelectName}</option>`);
    const nextSelectIndex = $nextSelect.data('index');
    availableVariants.forEach(variant => {
      $nextSelect.append(`<option value="${variant[nextSelectIndex]}">${variant[nextSelectIndex]}</option>`)
    })
  }

  if ($nextSelect.length && $nextSelect.is(':hidden')) {
    $nextSelect.show();
  } else if (!$nextSelect.length) {
    var selectedOptions = $currentSelect.closest('.variants-product-selects').find('select').map(function () { return $(this).val(); }).get();
    var productData = JSON.parse($currentSelect.closest('.infoProduct').find('[data-json-product]').text());

    var matchingVariant = productData.find(function (variant) {
      return selectedOptions.every(function (option, index) {
        return variant.options[index] === option;
      });
    });

    if (matchingVariant && matchingVariant.available) {
      $currentSelect.closest('.infoProduct').find('.variantIdAddCart').val(matchingVariant.id);
      $currentSelect.closest('.infoProduct').find('.recommend-btn-add').prop('disabled', false);
      $currentSelect.closest('.infoProduct').find('.recommend-btn-add').val('ADICIONAR');
    } else {
      $currentSelect.closest('.infoProduct').find('.recommend-btn-add').prop('disabled', true);
      $currentSelect.closest('.infoProduct').find('.recommend-btn-add').val('ESGOTADO');
      console.log('Produto esgotado');
    }
  }

  var container = $('.halo-cart-sidebar').find('.previewCart');
  var scrollTo = $('.halo-cart-sidebar').find('.recommend-container');

  // A posição de rolagem final é a posição do topo do .recommend-container mais sua altura
  var scrollPosition = scrollTo.offset().top + scrollTo.outerHeight() + container.scrollTop() - container.position().top;

  // Realiza a rolagem
  container.animate({
    scrollTop: scrollPosition
  }, 1000); // 1000 milissegundos para a animação de rolagem
});

document.addEventListener("DOMContentLoaded", function () {
  // Seleciona todos os vídeos com a classe 'lazyload-video'
  const lazyVideos = document.querySelectorAll(".lazyload-video");

  lazyVideos.forEach(video => {
    // Seleciona todas as fontes dentro do vídeo
    const sources = video.querySelectorAll("source");

    sources.forEach(source => {
      if (source.dataset.src) {
        // Move o 'data-src' para 'src'
        source.src = source.dataset.src;
        source.removeAttribute("data-src");
      }
    });

    // Após mudar as fontes, carrega o vídeo para aplicar a mudança
    video.load();

    // Muda a classe para 'lazyloaded-video'
    video.classList.remove("lazyload-video");
    video.classList.add("lazyloaded-video");
  });
});

if (document.body.classList.contains("template-product")) {
  const productImageWrapper = document.querySelector(".productView-nav.style-3");

  if (productImageWrapper) {
    const items = productImageWrapper.querySelectorAll(".productView-image");

    window.visibleItems = new Set();

    const getLastVisibleElement = (currLast, currValue) => {
      let cLast = currLast instanceof Node ? currLast.dataset.index : currLast;
      return Math.max(cLast, currValue.dataset.index);
    };

    const setScrollIndicator = (scrollIndex) => {
      const activeIndex =
        scrollIndex <= 2
          ? 1
          : scrollIndex == 3
          ? 2
          : Math.floor((scrollIndex + 2) / 2);

      const prevCurrent = document.querySelector(".scroll-indicator .current");
      const currCurrent = document.querySelector(`.scroll-indicator [data-scroll="${activeIndex}"]`);

      if (prevCurrent) prevCurrent.classList.remove("current");
      if (currCurrent) currCurrent.classList.add("current");
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            window.visibleItems.add(entry.target);
          } else {
            window.visibleItems.delete(entry.target);
          }
        });

        const lastIndex = Array.from(window.visibleItems).reduce(
          getLastVisibleElement,
          -Infinity
        );

        setScrollIndicator(lastIndex);
      },
      {
        root: productImageWrapper,
        threshold: 0.4,
      }
    );

    items.forEach((item) => observer.observe(item));
  }
}

function initPreviewCartCollection(scope = document) {
  if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') return;

  const carousels = scope.querySelectorAll('.previewCartCarousel');

  carousels.forEach((carousel) => {
    const $carousel = jQuery(carousel);
    const totalItems = carousel.querySelectorAll('.product').length;
    const showDots = carousel.dataset.itemDots === 'true';
    const showArrows = carousel.dataset.itemArrows === 'true';

    if (!totalItems) return;

    if ($carousel.hasClass('slick-initialized')) {
      $carousel.slick('unslick');
    }

    $carousel.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: totalItems > 1,
      adaptiveHeight: true,
      arrows: showArrows && totalItems > 1,
      dots: showDots && totalItems > 1,
      mobileFirst: false,
      prevArrow:
        '<button class="slick-prev slick-arrow" type="button" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true" focusable="false"><path d="M7.75 1.34375 L6.25 2.65625 L14.65625 12 L6.25 21.34375 L7.75 22.65625 L16.75 12.65625 L17.34375 12 L16.75 11.34375 Z"/></svg></button>',
      nextArrow:
        '<button class="slick-next slick-arrow" type="button" aria-label="Próximo"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8.25 1.34375 L6.84375 2.65625 L13.78125 12 L6.84375 21.34375 L8.25 22.65625 L16.25 12.65625 L16.84375 12 L16.25 11.34375 Z"/></svg></button>'
    });

    setTimeout(() => {
      if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('setPosition');
      }
    }, 100);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initPreviewCartCollection(document);
});

document.addEventListener('cart-update', function () {
  setTimeout(() => {
    initPreviewCartCollection(document);
  }, 150);
});

document.addEventListener('DOMContentLoaded', function () {
  if (window.__customMobileSubmenuInit) return;
  window.__customMobileSubmenuInit = true;

  document.addEventListener('click', function (event) {
    if (window.innerWidth > 1024) return;

    const lv1Trigger = event.target.closest(
      '.site-nav-mobile[data-navigation-mobile] .js-mobile-submenu-toggle'
    );

    const lv2Trigger = event.target.closest(
      '.site-nav-mobile[data-navigation-mobile] .js-mobile-submenu-toggle-2'
    );

    const trigger = lv1Trigger || lv2Trigger;
    if (!trigger) return;

    const item = trigger.closest(lv1Trigger ? '.menu-lv-1' : '.menu-lv-2');
    if (!item) return;

    const submenu = lv1Trigger
      ? item.querySelector(':scope > .header__submenu.expanded-menu--lv-2.mobile-only')
      : item.querySelector(':scope > .site-nav-list-dropdown > .header__submenu.expanded-menu--lv-3.mobile-only');

    if (!submenu) return;

    event.preventDefault();
    event.stopPropagation();

    const isOpen = item.classList.contains('is-open');

    const siblings = Array.from(item.parentElement.children).filter((el) => el !== item);

    siblings.forEach((sibling) => {
      sibling.classList.remove('is-open');
      sibling.querySelectorAll('.menu-lv-2.is-open').forEach((child) => {
        child.classList.remove('is-open');
      });
    });

    if (isOpen) {
      item.classList.remove('is-open');
      item.querySelectorAll('.menu-lv-2.is-open').forEach((child) => {
        child.classList.remove('is-open');
      });
    } else {
      item.classList.add('is-open');
    }
  });
});